<div class="container">

  <div class="container text-center mt-5">
    <span style="color:var(--primary-color);" class="fs-2 fw-medium ">Nuestros servicios de  <br><span class=" fw-bolder"> de laboratorio</span> </span>
  </div>

  <div class="container px-4 py-2" id="icon-grid">

    <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-3 g-5 py-5 justify-content-center ">
      <div *ngFor=" let service of services" class="col d-flex align-items-center ">
        <i style="color: var(--secondary-color); font-size: 10px" class=" bi bi-circle-fill px-2"></i>
        <div>
          <h3 class=" mb-0 fs-6 text-secondary">{{ service.name }}</h3>
        </div>
      </div>

    </div>
  </div>

</div>


<div class="container py-5 ">

  <div class="container text-center">
    <p class="fw-lighter fs-5 pt-2" style="color: var(--primary-color)">Más información al:</p>
  </div>


  <div class="d-grid gap-2 d-sm-flex justify-content-sm-center">
    <button class="buttonAction d-flex align-items-center justify-content-center">
      <img ngSrc="assets/img/movilink/llamadaIcon.svg" alt="llamadaLogo" class=" flex-shrink-0" height="30" width="30">
      <span class="text-light px-2 fs-1">5 50 50 52</span>
    </button>
    <a href="https://api.whatsapp.com/send/?phone=%2B593993183975&text&type=phone_number&app_absent=0" target="_blank" class="buttonAction d-flex align-items-center justify-content-center">
      <img ngSrc="assets/img/movilink/whatsapLogo.svg" alt="whatsapLogo" class=" flex-shrink-0" height="30" width="30">
      <span class="text-light px-2 fs-1">099 318 3975</span>
    </a>
  </div>



</div>

